import React, { createContext, useState, useContext } from 'react';

const FetchDateRangesContext = createContext(null);

export const FetchDateRangesProvider = ({ children }) => {
	const [fetchDateRanges, setFetchDateRanges] = useState(() => {});

	return (
		<FetchDateRangesContext.Provider
			value={{ fetchDateRanges, setFetchDateRanges }}
		>
			{children}
		</FetchDateRangesContext.Provider>
	);
};

export const useFetchDataRangesContextProvider = () => {
	return useContext(FetchDateRangesContext);
};
